import { combineReducers } from 'redux';

import calendarList from './calendarList/reducer';
import calendar from './calendar/reducer';

export default combineReducers({ calendarList, calendar });



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/state/reducer.js